import * as fromDatatype from "../datatype-library/index";

export interface bl_del_driver_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  phone_number: fromDatatype.VarcharDatatypeInterface;
  id_no: fromDatatype.VarcharDatatypeInterface;
  license_no: fromDatatype.VarcharDatatypeInterface;
  addresses_json: fromDatatype.JsonDatatypeInterface;
  join_date: fromDatatype.TimestampTzDatatypeInterface;
  driver_status: fromDatatype.VarcharDatatypeInterface;
  emergency_name: fromDatatype.TextDatatypeInterface;
  emergency_phone_number: fromDatatype.VarcharDatatypeInterface;
  relationship: fromDatatype.TextDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_del_driver_hdr_RowClass
  implements bl_del_driver_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  phone_number: fromDatatype.VarcharDatatypeInterface;
  id_no: fromDatatype.VarcharDatatypeInterface;
  license_no: fromDatatype.VarcharDatatypeInterface;
  addresses_json: fromDatatype.JsonDatatypeInterface;
  join_date: fromDatatype.TimestampTzDatatypeInterface;
  driver_status: fromDatatype.VarcharDatatypeInterface;
  emergency_name: fromDatatype.TextDatatypeInterface;
  emergency_phone_number: fromDatatype.VarcharDatatypeInterface;
  relationship: fromDatatype.TextDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
}
